"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeCover = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
// import { useScreenWidth } from "../../utils/customHooks/useScreenWidth";
var toArray_1 = require("../../utils/toArray");
var Buttons_1 = require("../Buttons");
var mixins_1 = require("../../themes/mixins");
var Typo_1 = require("../Typo");
var styled_1 = require("./styled");
var useScreenWidth_1 = require("../../utils/customHooks/useScreenWidth");
var HomeCover = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, desc = _a.desc, CTALink = _a.CTALink, customComp = _a.customComp, coverImagesConfig = _a.coverImagesConfig, _b = _a.variant, variant = _b === void 0 ? "default" : _b;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    var isDesktop = screenWidth > (0, mixins_1.getBreakPoint)("md");
    var navigate = (0, react_router_dom_1.useNavigate)();
    //   const {deployment: {_CoverImages : coverImagesConfig}} = useGetQueryData('platformConfigs');
    //backwards compat
    var _CoverImages = coverImagesConfig.every(function (c) { return typeof c === "string"; })
        ? coverImagesConfig
        : coverImagesConfig.map(function (c) { return c.publicUrl; });
    var _c = (0, react_1.useState)(undefined), dynamicTitleWidth = _c[0], setDynamicTitleWidth = _c[1];
    var initDesktopState = {
        currLayer: "layer1",
        layer1: [0, 1],
        layer2: [2, 3],
    };
    var initMobileState = {
        currLayer: "layer1",
        layer1: [0],
        layer2: [1],
    };
    var _d = (0, react_1.useState)(isDesktop ? initDesktopState : initMobileState), coverImageIdx = _d[0], setCoverImageIdx = _d[1];
    var firstMount = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        //basically if a switch happens between mobile and desktop then switch to the initial desktop / mobile state
        if (firstMount.current)
            firstMount.current = false;
        else {
            setCoverImageIdx(isDesktop ? initDesktopState : initMobileState);
        }
    }, [isDesktop]);
    var titleTextSpan_ref = (0, react_1.useRef)(null);
    var title_ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (titleTextSpan_ref.current) {
            var titleRect = title_ref.current.getBoundingClientRect();
            var titleTextSpanRect = titleTextSpan_ref.current.getBoundingClientRect();
            var titleWidth = titleRect.width;
            var spanWidth = titleTextSpanRect.width;
            var spanPadding = titleTextSpanRect.x - titleRect.x;
            if (spanPadding * 2 + spanWidth > titleWidth) {
                setDynamicTitleWidth(spanPadding * 2 + spanWidth);
            }
        }
        var interval, timeout;
        var intervalFlag = isDesktop ? 4 : 2;
        if (_CoverImages.length >= intervalFlag) {
            interval = setInterval(function () {
                // if(_CoverImages.length>=intervalFlag) {
                setCoverImageIdx(function (prev) {
                    return __assign(__assign({}, prev), { currLayer: prev.currLayer === "layer1" ? "layer2" : "layer1" });
                });
                timeout = setTimeout(function () {
                    setCoverImageIdx(function (prev) {
                        var _a;
                        var layerToSwitch = prev.currLayer === "layer1" ? "layer2" : "layer1";
                        return __assign(__assign({}, prev), (_a = {}, _a[layerToSwitch] = isDesktop
                            ? /**
                               * i.e there are 2 images showing ----------------> layer1 > img idx 0 | img idx 1
                               * the hidden layer below that will reveal has ---> layer2 > img idx 2 | img idx 3
                               *
                               * after reveal, 0 needs to become 4 & 1 needs to become 5
                               */
                                [
                                    (prev[layerToSwitch][0] + 4) % _CoverImages.length,
                                    (prev[layerToSwitch][1] + 4) % _CoverImages.length,
                                ]
                            : /**
                               * i.e there is only 1 image showing ----------------> layer1 > img idx 0
                               * the hidden layer below that will reveal has ---> layer2 > img idx 1
                               *
                               * after reveal, 0 needs to become 2 & 1 needs to become 3
                               */
                                [(prev[layerToSwitch][0] + 2) % _CoverImages.length], _a));
                    });
                }, 300); // the interval here shoudl be the same as the css transition interval
                // }
            }, 3000);
        }
        //resize title container if text is bleeding out due to long word
        return function () {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, [isDesktop]);
    var genCTALink = function (_a) {
        var CTALink = _a.CTALink, variant = _a.variant, isDesktop = _a.isDesktop;
        return CTALink && (react_1.default.createElement(Buttons_1.ButtonPrimary, { className: "HomeCover__cta", icon: "CaretRight", M: variant === "small" && !isDesktop && true, style: __assign({ position: "absolute", bottom: 0, borderRadius: 0, right: variant === "small" && !isDesktop ? "2rem" : 0 }, (variant === "small" && !isDesktop ? { zIndex: 100 } : {})), onClick: function () {
                navigate(CTALink);
            } }));
    };
    var TitleTypoComp = variant === "small" ? Typo_1.SERIF_8_9 : Typo_1.SERIF_9_10;
    return (react_1.default.createElement(styled_1.StyledHomeCover, { variant: variant },
        (title || subtitle) && (react_1.default.createElement(styled_1.StyledHomeCoverTitle, { ref: title_ref, style: dynamicTitleWidth && { width: dynamicTitleWidth + "px" }, variant: variant },
            react_1.default.createElement(TitleTypoComp, null,
                react_1.default.createElement("span", { ref: titleTextSpan_ref, className: "__textSpan" }, title)),
            subtitle && variant !== "small" && (react_1.default.createElement(Typo_1.SANS_3, { style: { paddingTop: "1rem" } }, subtitle)))),
        (variant !== "small" || isDesktop) && (react_1.default.createElement(styled_1.StyledHomeCoverDesc, null,
            react_1.default.createElement(styled_1.StyledHomeCoverDescContents, { variant: variant },
                desc &&
                    (0, toArray_1.toArray)(desc).map(function (d, i) { return (react_1.default.createElement(Typo_1.SERIF_3_4, { key: i, style: {
                            paddingBottom: i + 1 !== (0, toArray_1.toArray)(desc).length ? "1rem" : 0,
                        } }, d)); }),
                customComp && customComp,
                genCTALink({ CTALink: CTALink, variant: variant, isDesktop: isDesktop })))),
        variant === "small" &&
            !isDesktop &&
            genCTALink({ CTALink: CTALink, variant: variant, isDesktop: isDesktop }),
        react_1.default.createElement(styled_1.StyledHomeCoverImgWrapper, { breakPoint: variant === "small" && !isDesktop ? "lessThanMd_variantSmall" : "none" },
            react_1.default.createElement(styled_1.StyledHomeCoverImg, { backgroundImage: _CoverImages[coverImageIdx.layer1[0]], opacity: coverImageIdx.currLayer === "layer1" ? 1 : 0 }),
            react_1.default.createElement(styled_1.StyledHomeCoverImg, { backgroundImage: _CoverImages[coverImageIdx.layer2[0]], opacity: coverImageIdx.currLayer === "layer2" ? 1 : 0 })),
        isDesktop && (react_1.default.createElement(styled_1.StyledHomeCoverImgWrapper, { breakPoint: "md" },
            react_1.default.createElement(styled_1.StyledHomeCoverImg, { backgroundImage: _CoverImages[coverImageIdx.layer1[1]], opacity: coverImageIdx.currLayer === "layer1" ? 1 : 0 }),
            react_1.default.createElement(styled_1.StyledHomeCoverImg, { backgroundImage: _CoverImages[coverImageIdx.layer2[1]], opacity: coverImageIdx.currLayer === "layer2" ? 1 : 0 })))));
};
exports.HomeCover = HomeCover;
